import { useEffect } from 'react';

import styled from '@emotion/styled';
import { MenuSectionItem, Typography } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import { useRecentSearchKeyword } from '../../../../hooks';
import RecentSearchKeywordItem from './RecentSearchKeywordMenuItem';
import { useSearchPopover } from './SearchPopoverProvider';

const RecentSearchKeywords = () => {
  const { t } = useTranslation();
  const { recentSearchKeywords } = useRecentSearchKeyword();
  const { focusedIndex, setTotalItems } = useSearchPopover();

  useEffect(() => {
    setTotalItems(recentSearchKeywords.length);
  }, [recentSearchKeywords.length, setTotalItems]);

  return (
    <MenuSectionItem title={t('layout:search.recent.title')} expanded>
      <RecentSearchKeywordItemContainer>
        {recentSearchKeywords.length > 0 &&
          recentSearchKeywords.map((keyword, idx) => (
            <RecentSearchKeywordItem
              key={idx}
              name={keyword}
              index={idx}
              focused={focusedIndex === idx}
            />
          ))}
        {recentSearchKeywords.length === 0 && (
          <NoRecentSearchKeywordText variant={'label/regular/md'}>
            {t('layout:search.recent.empty')}
          </NoRecentSearchKeywordText>
        )}
      </RecentSearchKeywordItemContainer>
    </MenuSectionItem>
  );
};

const RecentSearchKeywordItemContainer = styled.ul`
  max-height: 280px;
  overflow-y: auto;
`;

const NoRecentSearchKeywordText = styled(Typography)`
  display: flex;
  align-items: center;
  height: 32px;
  padding: 10.5px 20px;
  color: #878e9b;
`;

export default RecentSearchKeywords;
